import React, { useEffect, createElement } from 'react';
import { LandingPage } from './pages/LandingPage';
import SeccionSecretaPage from './pages/seccion-secreta';
export default function App() {
  const path = window.location.pathname;
  // Meta Pixel initialization
  useEffect(() => {
    // Inject Meta Pixel script
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '1633635844670891');
      fbq('track', 'PageView');
      fbq('track', 'ViewContent');
    `;
    document.head.appendChild(script);
    // Add noscript fallback
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = 'https://www.facebook.com/tr?id=1633635844670891&ev=PageView&noscript=1';
    noscript.appendChild(img);
    document.body.appendChild(noscript);
    return () => {
      // Cleanup on unmount
      document.head.removeChild(script);
      document.body.removeChild(noscript);
    };
  }, []);
  // Si la URL es /seccion-secreta, mostramos la página secreta
  if (path === '/seccion-secreta') {
    return <SeccionSecretaPage data-id="element-0" />;
  }
  // En cualquier otra ruta, mostramos la landing normal
  return <LandingPage data-id="element-1" />;
}